import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/coupons/bulk/upload/upload_info", payload);
  },
};
